@if(isMenuOpen()){
    <div class="fixed top-[220px] left-0 right-0 bottom-0 bg-black/40 bg-opacity-40 z-[9998] transition-opacity duration-300"
        (click)="isMenuOpen.set(false)">
    </div>
    <div class="absolute z-[9999] bg-white w-full pb-5 rounded-b-lg transform transition-transform duration-300 translate-x-0 border-t border-[#ddd] max-h-[90dvh] overflow-auto"
        *transloco="let t; currentLang as currentLang">
        @if(isAuthenticated()){
            <div class="flex flex-col gap-6 p-3.5 m-4 border border-[#E4E7EC] rounded-lg shadow-[0_1px_2px_0_rgba(16,24,40,0.05)]">
                <div class="flex flex-col gap-2">
                    <div class="flex items-center gap-2">
                        <div
                            class="w-10 h-10 flex items-center justify-center aspect-square rounded-full bg-[#F1F9FE] border border-[#E2F2FC] shadow-[0_1px_2px_0_rgba(147,147,147,0.25),0_0_14px_-4px_rgba(0,157,255,0.30)_inset]">
                            <img [src]="environment.homeImageUrl + 'zap.svg'" alt="zap" class="w-[16px] h-[16px]" />
                        </div>
                        <p class="text-[#101828] text-sm font-semibold">{{t('update_profile')}}</p>
                    </div>
                    <div class="flex flex-col gap-1">
                        <div
                            class="w-full items-center flex justify-between border border-[#E2F2FC] rounded-md px-1 py-0.5 bg-[#F1F9FE]">
                            <a [href]="`${dashboardUrl}?lang=${currentLang}`" target="_blank" class="text-[#026AA2] text-xs font-medium">{{t('explore_stats')}}</a>
                            <img [src]="environment.homeImageUrl + 'arrow-down.svg'" alt="arrow-down" class="transform rotate-90 h-4" />
                        </div>
                    </div>
                </div>
                
                <div class="flex flex-col gap-4">
                    <app-profile-stat-card 
                        [percentage]="editProfilePercentage()"
                        [days]="profileCompletionInfo().lastProfileUpdateDate"
                        [label]="t('bdjobs_profile_completeness')"
                        [redirectUrl]="editProfileUrl">
                    </app-profile-stat-card>
                    <div class="w-full h-[1.5px] bg-[#E4E7EC]"></div>
                    <app-profile-stat-card 
                        [percentage]="videoCvPercentage()" 
                        [days]="profileCompletionInfo().lastVideoResumeUpdateDate"
                        [label]="t('video_cv_completeness')"
                        [redirectUrl]="videoCvUrl">
                    </app-profile-stat-card>
                </div>
                
            </div>
        }
        <ul 
            [class.pt-4]="!isAuthenticated()"
            class=" px-4 mb-4 flex flex-col gap-3.5 md:hidden">
            <li (click)="toggleSection('mybdjobs')"
                class="cursor-pointer relative flex items-center justify-between py-2">
                <img [src]="environment.homeImageUrl + 'mybdjobs.svg'" alt="mybdjobs" class="h-[25px]">
                <img [src]="environment.homeImageUrl + 'icon-down.svg'" alt="arrow-down" class="w-5 h-5" [class.rotate-180]="isSectionOpen('mybdjobs')">
            </li>
            @if(isSectionOpen('mybdjobs')){
            <div class="max-h-[70dvh] overflow-y-auto scroll-contain">
                @for(section of mybdjobsItem; track $index){
                <div class="bg-white  rounded-lg flex flex-col gap-3  ">
                    <p class="text-[#8C8C8C] font-medium text-xs">{{currentLang === 'en'? section.title.toUpperCase():
                        section.bnTitle}}</p>
                    <div class="flex flex-col gap-3.5 ">
                        @for (item of section.item; track $index) {
                        <a [href]="isAuthenticated() ? ( currentLang ==='en' ? item.url : item.bnUrl) : mybdjobsItemUrl()"
                            target="_blank" class="flex items-center gap-2.5 sm:gap-3 w-[200px]">
                            <img [src]="'images/' + item.imgName" class="bg-[#FCF3FA] rounded" />
                            <p class="text-[#344054] text-[15px] font-medium">{{ currentLang === 'en'? item.name:
                                item.bnName }}</p>
                        </a>
                        }
                    </div>
                    @if ($index
                    < mybdjobsItem.length - 1) { <hr class="mt-3 mb-5 border-t border-[#E4E7EC]" />
                    }
                </div>
                }
            </div>
            }
            <li (click)="toggleSection('jobs')"
                class="cursor-pointer relative flex items-center justify-between py-2">
                <p class="text-[#212121] font-medium text-base">{{t('jobs')}}</p>
                <img [src]="environment.homeImageUrl + 'icon-down.svg'" alt="arrow-down" class="w-5 h-5" [class.rotate-180]="isSectionOpen('jobs')">
            </li>
            @if(isSectionOpen('jobs')){
            <div class="bg-white rounded-lg flex flex-col gap-3.5">
                <div class="flex flex-wrap gap-4">
                    @for (item of jobsItem; track $index) {
                    @if(isAuthenticated() || item.title !=='Early Access Jobs' ){
                    <a (click)="onFilterUrlClick(item)" class="flex items-center gap-2.5 w-[200px]">
                        <img [src]="environment.homeImageUrl + item.imageUrl"  [class]="$index < 2 ? 'p-2' : 'p-0'"
                            class="bg-[#FCF3FA] rounded" />
                        <p class="text-[#344054] text-[15px] font-medium">{{ currentLang === 'en'? item.title: item.bnTitle
                            }}</p>
                    </a>
                    }
                    }
                </div>
            </div>
            }
            <li (click)="toggleSection('career')"
                class="cursor-pointer relative flex items-center justify-between">
                <p class="text-[#212121] font-medium text-base">{{t('CarResource')}}</p>
                <img [src]="environment.homeImageUrl + 'icon-down.svg'" alt="arrow-down" class="w-5 h-5"
                    [class.rotate-180]="isSectionOpen('career')">
            </li>
            @if(isSectionOpen('career')){
            <div class="bg-white rounded-lg flex flex-col gap-4">
                <div class="flex flex-wrap gap-4">
                    @for (item of careerResourceItem; track $index) {
                    <a [href]="item.url" target="_blank" class="flex items-center gap-3 w-[200px] px-3">
                        <p class="text-[#344054] text-[15px] font-medium">{{ currentLang === 'en' ? item.title :
                            item.bnTitle}}</p>
                    </a>
                    }
                </div>
            </div>
            }
            <li>
                <a href="https://mybdjobs.bdjobs.com/bdjobs-pro/bdjobs-pro-package-pricing" target="_blank"
                    class="cursor-pointer ">
                    <img [src]="environment.homeImageUrl + 'bdjobsPro.svg'" alt="bdjobsPro" class="h-[18px] my-2">
                </a>
            </li>
        </ul>
        <div class="border-t border-[#ddd] py-2">
            <div class="px-4 py-3 flex flex-col gap-[18px]">
    
                <a href="https://elearning.bdjobs.com/" target="_blank">
                    <img [src]="environment.homeImageUrl + 'e-learning.svg'" alt="">
                </a>
    
                <p (click)="onTenderClick()" class="text-[#212121] text-base font-medium">{{t('tender')}}</p>
                <!-- <a href="https://www.bdjobs.com/talent-search-dashboard" target="_blank" class="">
                    {{t('expert')}}
                </a> -->
                <a href="https://recruiter.bdjobs.com/" target="_blank" class="">
                    <img [src]="environment.homeImageUrl + 'recruiter.svg'" alt="recruiter">
                </a>
                @if(isEligibleForPersonalHiring()){
                <div>
                    <div class="flex items-center justify-between"
                        (click)="toggleSection('postJob')">
                        <p class="text-[#212121] text-base font-medium">{{t('post_a_job')}}</p>
                        <img [src]="environment.homeImageUrl + 'icon-down.svg'" alt="arrow-down" class="w-5 h-5"
                            [class.rotate-180]="isSectionOpen('postJob')">
                    </div>
                    @if(isSectionOpen('postJob')){
                    <div class="mt-2 flex flex-col px-4">
                        <a href="https://recruiter.bdjobs.com/jobposting/" target="_blank"
                            class="py-1.5 text-[#344054] rounded-md hover:bg-gray-50 text-[15px] font-medium">
                            {{t('post_job_for_your_company')}}
                        </a>
    
                        <!-- Item 2 -->
                        <!-- <a class="flex items-center gap-2 py-1.5 rounded-md hover:bg-gray-50 text-[15px] text-[#344054]"
                            href="https://mybdjobs.bdjobs.com/personalizedjobpost/bn/job-post/info" target="_blank">
                            <span class="whitespace-nowrap font-medium">{{t('post_Job_for_personal_hiring')}}</span>
                            <span
                                class="rounded-full bg-[#EEF4FF] px-2 py-0.5 text-xs font-medium
                                                                                       text-[#3538CD] border border-[#C7D7FE]">
                                {{t('new')}}
                            </span>
                        </a> -->
    
                    </div>
                    }
    
                </div>
                }@else {
                <a href="https://recruiter.bdjobs.com/jobposting/" target="_blank"
                    class="flex items-center justify-between">
                    <p class="text-[#212121] text-base font-medium">{{t('post_a_job')}}</p>
                </a>
                }
                <div class=" flex justify-between items-center pb-4">
                    <span class="font-medium text-base text-[#212121] ">{{t('language')}}</span>
                    <div
                        class="relative md:hidden inline-block w-[96px] shadow-sm rounded-full border border-gray-100 px-0.5 py-0.5">
                        <input type="checkbox" id="changeLanguage" [checked]="currentLang === 'bn'"
                            (change)="toggleLang($event)" class="sr-only peer" />
                        <label for="changeLanguage"
                            class="toggle-label block h-7 cursor-pointer overflow-hidden rounded-full bg-white"></label>
                        <div [class.left-0.5]="currentLang==='en'" [class.left-0]="currentLang==='bn'"
                            class="toggle-button absolute top-0.5 left-0 h-[29px] w-[47px] rounded-full  bg-[#c13e8a] transform transition-transform peer-checked:translate-x-full peer-checked:border-white">
                        </div>
                        <span
                            class="pointer-events-none absolute left-3.5 top-[60%] -translate-y-1/2 h-[21px] transform text-[10px] font-semibold text-white peer-checked:text-[#757575]">
                            ENG
                        </span>
                        <span
                            class="pointer-events-none absolute right-2.5 top-[60%] -translate-y-1/2 h-[21px] transform text-[10px] font-semibold text-[#757575] peer-checked:text-white">
                            বাংলা
                        </span>
                    </div>
                </div>
            </div>
        </div>
        @if(!isAuthenticated()){
        <div class="px-3 py-4 pb-2 border-t border-[#ddd]">
            <div class="flex items-center justify-between"
                (click)="toggleSection('employer')">
                <p class="text-[#212121] text-base font-medium">{{t('forEmployerLogin')}}</p>
                <img [src]="environment.homeImageUrl + 'icon-down.svg'" alt="arrow-down" class="w-5 h-5"
                    [class.rotate-180]="isSectionOpen('employer')">
            </div>
            @if(isSectionOpen('employer')){
            <div class="flex flex-col gap-1 py-1.5 px-2">
                <a href="https://recruiter.bdjobs.com/"
                    class="cursor-pointer w-full text-left px-2 py-2 text-[15px] text-[#344054] hover:bg-gray-50">
                    {{ t('signin') }}
                </a>
    
                <a href="https://recruiter.bdjobs.com/RecruiterAccount/register" target="_blank"
                    class="cursor-pointer w-full text-left px-2 py-2 text-[15px] text-[#344054] hover:bg-gray-50">
                    {{ t('createAccount') }}
                </a>
            </div>
            }
    
        </div>
        }
        @if(isAuthenticated()){
        <a [href]="'https://bdjobs.com/contact.asp'" target="_blank"
            class="mx-4 mb-5 border border-[#2F64A3] rounded-lg w-auto h-10 text-[#2F64A3] flex items-center justify-center gap-2 font-semibold">
            <img [src]="environment.homeImageUrl + 'call-icon.svg'" />
            {{t('contact_us')}}
        </a>
        }
    </div>
}


@if(isMessageRes() && isMobileDevice()){
<div class="fixed inset-0 h-dvh w-full overflow-hidden bg-white z-[10000] isolate" *transloco="let t; currentLang as currentLang">
    <div class="flex items-center py-4 gap-x-2 px-4">
        <div (click)="isMessageRes.set(false)" class="cursor-pointer">
            <img [src]="environment.homeImageUrl + 'arrow-left1.svg'" alt="" class="w-5 h-5">
        </div>
        <div class="text-base  font-semibold text-[#101828]">
            {{t('message')}}
        </div>
    </div>
    <div class="border-b border-[#ddd] w-full"> </div>
    <div class="flex flex-col justify-between">
        <div class="flex-1 overflow-y-auto pb-[88px]">
            @for(message of messageList(); track $index ){
            <a [href]="`${mybdjobsMsgUrl}?jobId=${message.jobId}`" target="_blank" class="flex py-3 px-5">
                <div class="">
                    @if(message.companyLogo){
                    <img [src]="message.companyLogo" alt="" class="h-8 w-8 rounded-full">
                    }
                    @else {
                    <img [src]="environment.homeImageUrl + 'avatar.svg'" alt="" class="h-8 w-8 rounded-full">
                    }
                </div>
                <div class="flex flex-col pl-4">
                    <div class="text-xs font-medium text-[#475467]">{{message.companyName}}</div>
                    <div class="text-xs font-semibold text-[#344054]">{{ 'sentInRole' | transloco: { jobTitle:
                        message.jobTitle } }}
                    </div>
                    <div class="flex gap-x-1 items-center mt-[6px]">
                        <div class=" ">
                            <img [src]="environment.homeImageUrl + 'clock.svg'" alt="" class="h-3 w-3">
                        </div>
                        <div class="text-xs text-[#475467]">{{message.lastChattedOn| time: activeLang() }}</div>
                    </div>
                </div>
            </a>

            <div class="border-b border-[#ddd] w-full"> </div>
            }
            @empty {
            <div class="flex flex-col items-center justify-center  overflow-hidden min-h-screen">
                <img [src]="environment.homeImageUrl + 'messages.svg'" [class]="isProUser() ? '-mt-48' : '-mt-12'" class="block">
                <div class="-mt-[136px] text-center gap-1">
                    <p
                        class="text-center mb-1 mt-4 text-[#101828] text-xl font-semibold flex items-center justify-center">
                        {{t('messages')}}
                    </p>
                    <p
                        class="mx-auto max-w-[90vw]  gap-x-1 text-[#475467] text-[13px] text-center">
                        <span>{{t('messagesHint')}}</span>

                        <span class="block items-center gap-x-1">
                            <span>{{t('feature')}}</span>
                        </span>
                    </p>
                    @if(!isProUser()){
                    <a [href]="pricingPageUrl" target="_blank"
                        class="mb-12 mt-5 mx-auto max-w-fit flex items-center justify-center text-center bg-[#0DB14B] hover:bg-[#008020] rounded-lg px-3.5 py-2.5 font-semibold text-sm text-white flex items-center gap-1.5">
                        <span>{{t('getBdjobsPro')}}</span>
                        <img [src]="environment.homeImageUrl + 'arrow-right-white.svg'" />
                    </a>
                    }

                </div>
            </div>
            }
        </div>
        @if(messageList().length > 0){
        <div
            class="fixed bottom-0 left-0 w-full bg-white border-t border-[#E4E7EC] shadow-[0_-12px_14px_-4px_rgba(16,24,40,0.06)]">
            <div class="flex justify-between items-center p-5 py-4">
                <!-- <div class="text-[#0E6596] text-[14px] flex items-center ">
                    <img src="images/check.svg" alt="" class="pr-[6px]">
                    <div>{{t('markAsRead')}}</div>
                </div> -->
                <a href="https://mybdjobs.bdjobs.com/mybdjobs/employer-message.asp?p=m" target="_blank" class="ml-auto">
                    <div class="text-white bg-[#C63C92] rounded-lg px-3.5 py-2.5 text-[14px] font-semibold">
                        {{t('viewAll')}}</div>
                </a>
            </div>
        </div>
        }
    </div>
</div>
}

@if(isNotificationRes() && isMobileDevice()){
<div class="fixed inset-0 h-dvh w-full overflow-hidden bg-white z-[10000] isolate" *transloco="let t; currentLang as currentLang">
    <div class="flex items-center pt-4 pb-1 gap-x-2 px-4">
        <div (click)="isNotificationRes.set(false)" class="cursor-pointer">
            <img [src]="environment.homeImageUrl + 'arrow-left1.svg'" alt="" class="w-5 h-5">
        </div>
        <div class="text-base  font-semibold text-[#101828]">
            {{t('notifications')}}
        </div>
    </div>
    <div class="">
        <div class="flex gap-6 border-b border-[#E4E7EC] pt-4 pl-4">
            <button class="pb-2 text-sm  cursor-pointer" [class]="activeNotificationTab() === 'alerts'
                              ? 'text-[#B32D7D] border-b-2 border-[#B32D7D] font-semibold'
                              : 'text-[#667085] font-medium'" (click)="activeNotificationTab.set('alerts')">
                {{t('alert')}}
            </button>

            <button class="pb-2 text-sm  cursor-pointer" [class]="activeNotificationTab() === 'reminders'
                              ? 'text-[#B32D7D] border-b-2 border-[#B32D7D] font-semibold'
                              : 'text-[#667085] font-medium'" (click)="activeNotificationTab.set('reminders')">
                {{t('rem')}}
            </button>
        </div>
    </div>
    <div class="grid grid-rows-[auto_1fr] h-[90%] overflow-y-auto">
        @if(activeNotificationTab() === 'alerts'){
        <div class="flex flex-col  h-screen">
            @for(alert of alerts(); track $index){
            <div class="flex items-start py-2.5 px-5 gap-3" [class]="alert.timestamp === null ? 'bg-[#FCF3FA]' : ''"
                (click)="redirectNotification(alert, true)">
                <div class="relative">
                    <img [src]="alert.icon" class="max-w-10 max-h-10 min-w-10 min-h-10 rounded-full" />
                    @if(alert.timestamp === null){
                    <img class="absolute  top-4 right-[43px]" [src]="environment.homeImageUrl + 'ellipse.svg'" alt="">
                    }
                </div>
                <div class="flex flex-col">
                    <div class="text-xs font-medium text-[#475467]">{{alert.title}}</div>
                    @if(!isProUser() && (alert.notificationType === 4 || alert.notificationType === 6 )){
                    <div class="text-sm text-[#344054] font-semibold ">{{ alert?.message | truncate : 90}}</div>
                    } @else if (alert.metadata && alert.metadata.name) {
                    <div class="text-sm text-[#344054] font-semibold "> {{ alert.metadata.name + ' ' + alert.message |
                        truncate : 90}}</div>
                    } @else {
                    <div class="text-sm text-[#344054] font-semibold "> {{ alert.message | truncate : 90}} </div>
                    }
                    @if (alert.metadata) {
                    <div class="flex gap-x-1 items-center  pt-[6px]">
                        <div class="">
                            <img [src]="environment.homeImageUrl + 'clock.svg'" alt="" class="h-3.5 w-3.5">
                        </div>
                        <div class="text-xs text-[#475467] text-[#475467]">{{alert.metadata.minutes | time: activeLang()
                            }}</div>
                    </div>
                    }
                </div>
            </div>
            <div class="border-b border-[#ddd] w-full"> </div>
            }
            @empty {
            <div class="min-h-screen w-full overflow-hidden flex items-center justify-center ">
                <div class="relative flex items-center justify-center -mt-16">
                    <img [src]="environment.homeImageUrl + 'Alerts.svg'" class="block max-h-[70vh] w-auto" />

                    <p
                        class="whitespace-nowrap absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-[-25px] text-[#101828] text-xl font-semibold">
                        {{ t('alerts') }}
                    </p>
                </div>
            </div>

            }
        </div>
        }
        @if(activeNotificationTab() === 'reminders'){
        <div class="flex flex-col gap-4 pt-2 pb-4 min-h-[calc(100vh-90px)]">
            @for(reminder of reminders(); track $index){
            <div class="flex flex-col text-xs px-6" (click)="redirectNotification(reminder, false)">
                <div class="text-xs text-[#475467] font-semibold pb-1">
                    {{reminder.metadata.systemName}}
                </div>
                <div class="text-xs text-[#475467] font-semibold pb-[6px]">
                    {{reminder.message}}
                </div>
                <div class="text-xs text-[#475467] font-medium pb-[6px]">
                    {{reminder.metadata.messageDetail}}
                </div>
                @if(reminder.metadata.imageUrl){
                <img [src]="reminder.metadata.imageUrl" alt="" class="w-full h-[142px] rounded-lg">
                }
                <div class="flex gap-x-1 items-center mt-[6px]">
                    <div class=" pb-[6px]">
                        <img [src]="environment.homeImageUrl + 'clock.svg'" alt="" class="h-3 w-3">
                    </div>
                    <div class="text-xs text-[#475467] text-[#475467]">{{reminder.metadata.minutesAgo | time:
                        activeLang() }}</div>
                </div>
            </div>
            <div class="border-b border-[#ddd] w-full py-2"> </div>
            }
            @empty {
                <div class="h-full flex items-center justify-center overflow-hidden">
                    <div class="-mt-48 flex flex-col items-center text-center gap-4">
                        <img [src]="environment.homeImageUrl + 'Reminders.svg'" class="block max-w-full h-auto" />
                        <p class="-mt-[136px] text-[#101828] text-xl font-semibold">
                            {{ t('reminders') }}
                        </p>
                    </div>
                </div>
            }
        </div>
        }
        <!-- <div class="bg-[#E4E7EC]"></div> -->
        @if(
        activeNotificationTab() === 'alerts'
        ? (alerts().length) > 0
        : (reminders().length) > 0
        ) {
        <div
            class="fixed bottom-0 left-0 w-full bg-white border-t border-[#E4E7EC] shadow-[0_-12px_14px_-4px_rgba(16,24,40,0.06),0_4px_10px_-2px_rgba(16,24,40,0.03)]">
            <div class="flex justify-between items-center p-4">
                <button [disabled]="unreadNotification() <= 0" (click)="onMarkAllAsReadClick()" class="text-[#0E6596] text-xs flex items-center disabled:cursor-not-allowed disabled:opacity-30 ">
                    <img [src]="environment.homeImageUrl + 'check.svg'" alt="" class="pr-[6px]">
                    <div>{{t('markAsRead')}}</div>
                </button>
                <a href="https://mybdjobs.bdjobs.com/mybdjobs/view-all-notification-message.asp?p=n" target="_blank"
                    target="_blank">
                    <div class="text-white bg-[#C63C92] rounded-lg px-3.5 py-2.5 text-xs font-semibold no-warp">
                        {{t('viewNotifications')}}</div>
                </a>
            </div>
        </div>
        }
    </div>
</div>
}
